export default "__VITE_ASSET__DglfRowz__"